import { render, staticRenderFns } from "./roleAdd.vue?vue&type=template&id=a3c629e2&scoped=true&"
import script from "./roleAdd.vue?vue&type=script&lang=js&"
export * from "./roleAdd.vue?vue&type=script&lang=js&"
import style0 from "./roleAdd.vue?vue&type=style&index=0&id=a3c629e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c629e2",
  null
  
)

export default component.exports